import React, { useEffect, useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [mapError, setMapError] = useState(false);
  
  useEffect(() => {
    // Initialize map function
    const initMap = function() {
      try {
        if (!(window as any).google || !(window as any).google.maps) {
          setMapError(true);
          return;
        }
        
        const mapElement = document.getElementById('map');
        if (!mapElement) return;
        
        const officeLocation = { lat: 13.7246, lng: 100.5233 }; // Silom, Bangkok coordinates
        
        const map = new (window as any).google.maps.Map(mapElement, {
          zoom: 15,
          center: officeLocation,
        });
        
        const marker = new (window as any).google.maps.Marker({
          position: officeLocation,
          map: map,
          title: '707 M CO., LTD. - สำนักงานใหญ่'
        });
        
        const infoWindow = new (window as any).google.maps.InfoWindow({
          content: '<div><h3>707 M CO., LTD.</h3><p>968 อาคารอื้อจือเหลียง ชั้นที่ 5 ถนนพระรามที่ 4 แขวงสีลม เขตบางรัก กรุงเทพมหานคร 10500</p></div>'
        });
        
        marker.addListener('click', function() {
          infoWindow.open(map, marker);
        });
      } catch (error) {
        console.error('Error initializing map:', error);
        setMapError(true);
      }
    };
    
    // Assign initMap to window
    (window as any).initMap = initMap;
    
    // Check if Google Maps API is already loaded
    if ((window as any).google && (window as any).google.maps) {
      initMap();
      return;
    }
    
    // Load Google Maps script with error handling
    const script = document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&callback=initMap';
    script.async = true;
    script.defer = true;
    
    script.onerror = function() {
      console.error('Failed to load Google Maps script');
      setMapError(true);
    };
    
    script.onload = function() {
      // Set a timeout to check if the map was initialized
      setTimeout(() => {
        const mapElement = document.getElementById('map');
        if (mapElement && !mapElement.hasChildNodes()) {
          setMapError(true);
        }
      }, 3000);
    };
    
    // Add script to document head
    try {
      document.head.appendChild(script);
    } catch (error) {
      console.error('Error adding Google Maps script to document:', error);
      setMapError(true);
    }
    
    return () => {
      // Clean up
      (window as any).initMap = undefined;
    };
  }, []);

  return (
    <div className="contact-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <h1>ติดต่อเรา</h1>
          <p>ติดต่อกับ 707 M CO., LTD.</p>
        </div>
      </section>

      {/* Contact Info & Map Section */}
      <section className="section contact-section">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="contact-info">
                <h2>พูดคุยกับเรา</h2>
                <p>สอบถามข้อมูลเกี่ยวกับผลิตภัณฑ์หรือบริการของเราได้ทุกเวลา เรายินดีให้คำปรึกษา</p>
                
                <div className="contact-item">
                  <h3>ที่อยู่</h3>
                  <p>968 อาคารอื้อจือเหลียง ชั้นที่ 5<br />
                  ถนนพระรามที่ 4 แขวงสีลม<br />
                  เขตบางรัก กรุงเทพมหานคร 10500</p>
                </div>
                
                <div className="contact-item">
                  <h3>โทรศัพท์</h3>
                  <p>+66 2 234 5678</p>
                </div>
                
                <div className="contact-item">
                  <h3>อีเมล</h3>
                  <p>info@707m.co.th</p>
                </div>
                
                <div className="contact-item">
                  <h3>เวลาทำการ</h3>
                  <p>วันจันทร์ - วันศุกร์: 9:00 น. - 18:00 น.<br />
                  วันเสาร์: 9:00 น. - 13:00 น.<br />
                  วันอาทิตย์: ปิดทำการ</p>
                </div>
              </div>
            </div>
            
            <div className="col-md-6">
              <div className="contact-form">
                <h2>ส่งข้อความถึงเรา</h2>
                <form>
                  <div className="form-group">
                    <label htmlFor="name">ชื่อ</label>
                    <input type="text" id="name" name="name" required />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="email">อีเมล</label>
                    <input type="email" id="email" name="email" required />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="phone">โทรศัพท์</label>
                    <input type="tel" id="phone" name="phone" />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="subject">หัวข้อ</label>
                    <input type="text" id="subject" name="subject" required />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="message">ข้อความ</label>
                    <textarea id="message" name="message" rows={5} required></textarea>
                  </div>
                  
                  <button type="submit" className="btn btn-primary">ส่งข้อความ</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="section map-section">
        <div className="container">
          <div className="section-title">
            <h2>แผนที่</h2>
          </div>
          <div className="map-container">
            {mapError ? (
              <div className="map-error">
                ไม่สามารถโหลดแผนที่ได้ โปรดตรวจสอบการเชื่อมต่ออินเทอร์เน็ต
              </div>
            ) : (
              <div id="map" className="map"></div>
            )}
          </div>
        </div>
      </section>

      {/* Additional Info Section */}
      <section className="section additional-info bg-light">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div className="info-card">
                <h3>ข้อมูลการจดทะเบียนบริษัท</h3>
                <p>ทะเบียน: 0105567253957</p>
                <p>จดทะเบียน: 23 ธันวาคม 2567</p>
                <p>ทุนจดทะเบียน: 3,000,000 บาท</p>
              </div>
            </div>
            
            <div className="col-md-4">
              <div className="info-card">
                <h3>ประเภทธุรกิจ</h3>
                <p>การขายส่งสินค้าทั่วไป</p>
                <p>จำหน่ายกระติกสูญญากาศ</p>
                <p>นำเข้าและส่งออกสินค้า</p>
              </div>
            </div>
            
            <div className="col-md-4">
              <div className="info-card">
                <h3>ติดตามเรา</h3>
                <p>ติดตามข่าวสารและโปรโมชั่นของเราได้ผ่านโซเชียลมีเดีย</p>
                <div className="social-links">
                  <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-link">Facebook</a>
                  <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link">Instagram</a>
                  <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link">LinkedIn</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
